import React from 'react';
import PropTypes from 'prop-types';
import styles from '../region-entity-banner.module.scss';
import { humanizeNumber, sentenceCase } from '../../helpers/formatters';
import { RegionTypeMapper } from '../../helpers/label-mapper';

const RegionMapBanner = ({ council }) => {
  return (
    <div className={`${styles.banner} ${styles.mapBanner}`}>
      <h2 className={styles.mapBannerHeading}>{council.lgaName}</h2>
      <div className={styles.mapBannerWrapper}>
        <div className={styles.mapBannerDataRow}>
          <div
            className={styles.mapBannerDataBlockWrapper}
            style={{ marginRight: 40 }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/img/people-icon.svg`}
              alt="house icon"
              width="35"
              height="46"
            />
            <div className={styles.mapBannerDataBlockContent}>
              <div className={styles.mapBannerDataNumber}>
                {humanizeNumber(council.population2018, 'number')}
              </div>
              <span>people</span>
            </div>
          </div>

          <div
            className={styles.mapBannerDataBlockWrapper}
            style={{ marginRight: 40 }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/img/income-icon.svg`}
              alt="people icon"
              width="35"
              height="46"
            />
            <div className={styles.mapBannerDataBlockContent}>
              <div className={styles.mapBannerDataNumber}>
                {humanizeNumber(council.medianIncome2017, 'currency')}
              </div>
              <span>median income</span>
            </div>
          </div>

          <div className={styles.mapBannerDataBlockWrapper}>
            <img
              src={`${process.env.PUBLIC_URL}/img/age-icon.svg`}
              alt="area icon"
              width="35"
              height="46"
            />
            <div className={styles.mapBannerDataBlockContent}>
              <div className={styles.mapBannerDataNumber}>
                {humanizeNumber(council.medianAge2018, 'number')}
              </div>
              <span>median age</span>
            </div>
          </div>
          <div className={styles.mapBannerLegend}>
            <span> This demographic data was sourced from the</span>
            <a
              className={styles.externalLink}
              href="http://www.abs.gov.au/"
              rel="noopener noreferrer"
              target="_blank"
            >
              Australian Bureau of Statistics{' '}
            </a>
            and represents the average of median statistics for the local
            government areas that make up this region.
          </div>
        </div>
        <div className={styles.mapBannerInfoContainer}>
          <p className={styles.mapBannerInfo}>
            <span className={styles.mapBannerInfoKey}>Region: </span>
            <span className={styles.mapBannerInfoValue}>
              {RegionTypeMapper[council.highLevelClassification]}
            </span>
          </p>
          <p className={styles.mapBannerInfo}>
            <span className={styles.mapBannerInfoKey}>
              Primary industries:{' '}
            </span>
            <span className={styles.mapBannerInfoValue}>
              {sentenceCase(council.rtpPrimaryIndustrySector)}
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

RegionMapBanner.propTypes = {
  council: PropTypes.object,
};

export default RegionMapBanner;



// WEBPACK FOOTER //
// ./src/components/region-map/region-map-banner.js